import React, { createContext, useContext, useEffect, useState} from 'react';
import Cookies from 'js-cookie';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false); 

  const savedTheme = Cookies.get('theme');

  useEffect(() => {
    
    if (savedTheme !== 'dark') {
      return
    }

    setDarkMode(true);
  }, []);

  return (
    <ThemeContext.Provider value={{darkMode, setDarkMode}}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);